import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { NotFoundErrorScreen } from "src/apps/routes/NotFoundErrorScreen";
import { DocumentationAreaScreen } from "src/apps/routes/documentationArea/DocumentationAreaScreen";
import { BasicDataScreen } from "./onboarding/BasicDataScreen";
import { DocumentationAreaProvider } from "../providers/DocumentationAreaProvider";
import { LoginScreen } from "./onboarding/LoginScreen";
import { TwoFactorScreen } from "./onboarding/TwoFactorScreen";
import { ProtectedRoute } from "./protectedRoute/ProtectedRoute";
import { AuthenticationRedirect } from "./redirects/AuthenticationRedirect";
import { MissingEmailRedirect } from "./redirects/MissingEmailRedirect";
import { ConsentsScreen } from "./onboarding/ConsentsScreen";
import { NotificationsProvider } from "../providers/NotificationsProvider";
import { CallbackScreen } from "./onboarding/CallbackScreen";
import { AnalyticsProvider } from "../providers/AnalyticsProvider";

export function Navigation() {
  return <AppNavigator />;
}

export const DOCUMENTATION_AREA_ROUTES = {
  LOGIN: "/login",
  TWO_FACTOR: "/two-factor",
  BASIC_DATA: "/basic-data",
  CONSENTS: "/consents",
  HOME: "/",
  NOT_FOUND_SCREEN: "/not-found",
  CALLBACK: "/callback",
};

function AppNavigator() {
  return (
    <AnalyticsProvider>
      <Routes>
        <Route
          path={DOCUMENTATION_AREA_ROUTES.LOGIN}
          element={
            <AuthenticationRedirect>
              <LoginScreen />
            </AuthenticationRedirect>
          }
        />
        <Route
          path={DOCUMENTATION_AREA_ROUTES.TWO_FACTOR}
          element={
            <MissingEmailRedirect>
              <TwoFactorScreen />
            </MissingEmailRedirect>
          }
        />
        <Route path={DOCUMENTATION_AREA_ROUTES.CALLBACK} element={<CallbackScreen />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DocumentationAreaProvider>
                <AnalyticsProvider>
                  <NotificationsProvider>
                    <Outlet />
                  </NotificationsProvider>
                </AnalyticsProvider>
              </DocumentationAreaProvider>
            </ProtectedRoute>
          }
        >
          <Route path={DOCUMENTATION_AREA_ROUTES.HOME} element={<DocumentationAreaScreen />} />
          <Route path={DOCUMENTATION_AREA_ROUTES.CONSENTS} element={<ConsentsScreen />} />
          <Route path={DOCUMENTATION_AREA_ROUTES.BASIC_DATA} element={<BasicDataScreen />} />
        </Route>
        <Route
          path={DOCUMENTATION_AREA_ROUTES.NOT_FOUND_SCREEN}
          element={<NotFoundErrorScreen />}
        />
        <Route
          path="*"
          element={
            <Navigate to={`${DOCUMENTATION_AREA_ROUTES.NOT_FOUND_SCREEN}${location.search}`} />
          }
        />
      </Routes>
    </AnalyticsProvider>
  );
}
